import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS, MatchesWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsLowercase, IsNotEmpty, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
import { PatchWebMerchantAppDto } from './PatchWebMerchantAppDto';
import { PatchWebMerchantMetadataDto } from './PatchWebMerchantMetadataDto';
export class PatchWebMerchantDto {
    constructor() {
        this.metadata = new PatchWebMerchantMetadataDto();
        this.app = new PatchWebMerchantAppDto();
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
            WebMerchantExposeGroup.SEARCH,
        ],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsLowercase({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    MatchesWithLVS(/[a-z-]+/, { always: true }),
    IsUndefinable({ groups: [WebMerchantExposeGroup.SEARCH, WebMerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebMerchantDto.prototype, "slug", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
            WebMerchantExposeGroup.SEARCH,
        ],
    }),
    IsOptional({ always: true }),
    IsUndefinable({ groups: [WebMerchantExposeGroup.SEARCH, WebMerchantExposeGroup.PATCH] }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantDto.prototype, "hostname", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Uses for set webstore for default styling' }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUUID('4', { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantDto.prototype, "defaultStyleWebStoreId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchWebMerchantMetadataDto }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsDefined({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ groups: [WebMerchantExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => PatchWebMerchantMetadataDto),
    __metadata("design:type", PatchWebMerchantMetadataDto)
], PatchWebMerchantDto.prototype, "metadata", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchWebMerchantAppDto }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsDefined({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ groups: [WebMerchantExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => PatchWebMerchantAppDto),
    __metadata("design:type", PatchWebMerchantAppDto)
], PatchWebMerchantDto.prototype, "app", void 0);
//# sourceMappingURL=PatchWebMerchantDto.js.map